export default __webpack_public_path__ + "static/media/foo-w.95f5d774.svg";